import React from 'react';

const HousePentagonAltIcon = ({ width = 20, height = 20, fill = 'none' }) => (
  <svg
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill={fill}
  >
    <g clipPath="url(#clip0_2642_1407)">
      <path
        d="M1.02539 10.1645L9.66592 1.52393L18.3064 10.1645V16.8849C18.3064 17.3941 18.1041 17.8825 17.7441 18.2426C17.384 18.6027 16.8956 18.805 16.3863 18.805H2.94551C2.43626 18.805 1.94787 18.6027 1.58778 18.2426C1.22769 17.8825 1.02539 17.3941 1.02539 16.8849V10.1645Z"
        stroke="#222222"
        strokeWidth="1.92012"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.66797 18.8048V13.0444"
        stroke="#222222"
        strokeWidth="1.92012"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2642_1407">
        <rect
          width="19.2012"
          height="19.2012"
          fill="white"
          transform="translate(0.0664062 0.563477)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default HousePentagonAltIcon;
